// See Chakra theme typography docs: https://v2.chakra-ui.com/docs/styled-system/theme#typography
const FONT_SIZE_XS = "11px";
const FONT_SIZE_S = "13px";
const FONT_SIZE_M = "14px";
const FONT_SIZE_L = "15px";
const FONT_SIZE_XL = "16px";
const FONT_SIZE_2XL = "18px";
const FONT_SIZE_3XL = "20px";
const FONT_SIZE_4XL = "24px";
const FONT_SIZE_5XL = "40px";

const typography = {
  fonts: {
    body: `Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
    heading: `Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
  },
  fontSizes: {
    "xs": FONT_SIZE_XS,
    "sm": FONT_SIZE_S,
    "md": FONT_SIZE_M,
    "lg": FONT_SIZE_L,
    "xl": FONT_SIZE_XL,
    "2xl": FONT_SIZE_2XL,
    "3xl": FONT_SIZE_3XL,
    "4xl": FONT_SIZE_4XL,
    "5xl": "28px",
    "6xl": "32px",
    "7xl": FONT_SIZE_5XL,
  },
  textStyles: {
    subtle: {
      fontSize: [FONT_SIZE_XS],
      fontWeight: "normal",
    },
    body: {
      fontSize: [FONT_SIZE_S],
      fontWeight: "normal",
    },
    bodyBold: {
      fontSize: [FONT_SIZE_S],
      fontWeight: "bold",
    },
    cardBody: {
      fontSize: [FONT_SIZE_L],
      fontWeight: "normal",
    }
  }
};

export { FONT_SIZE_L, FONT_SIZE_M, FONT_SIZE_S, FONT_SIZE_XS, FONT_SIZE_XL, FONT_SIZE_2XL, FONT_SIZE_3XL, FONT_SIZE_4XL, FONT_SIZE_5XL, typography };

